import { render } from "./Age.vue?vue&type=template&id=542b12bc&scoped=true&ts=true"
import script from "./Age.vue?vue&type=script&lang=ts"
export * from "./Age.vue?vue&type=script&lang=ts"

import "./Age.vue?vue&type=style&index=0&id=542b12bc&lang=scss&scoped=true"

import exportComponent from "/var/www/html/drupal/modules/custom/nvschade_calculator/assets/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-542b12bc"]])

export default __exports__